import { deleteStorage, getStorage, setStorage } from "./storage";

const STORAGE_KEY = 'u4OrgsOff';
const LEGACY_KEY = 'u4Orgs';

export const getUserOrgs = (authUser) => {
    const orgs = authUser?.hotels ?? [];
    if (orgs.length) return orgs;
    if (!authUser?.hotel_id) return [];
    return [{ id: authUser.hotel_id, name: authUser?.hotel?.name ?? 'My organisation' }];
};

const memberOrgIds = (authUser) =>
    getUserOrgs(authUser).map((o) => Number(o?.id)).filter(Boolean);

const readDeselected = () => {
    try {
        const stored = getStorage(STORAGE_KEY);
        return Array.isArray(stored) ? stored.map(Number) : [];
    } catch (e) {
        return [];
    }
};

export const getSelectedOrgIds = (authUser) => {
    const memberIds = memberOrgIds(authUser);
    const deselected = readDeselected();
    if (!deselected.length) return memberIds;

    const selected = memberIds.filter((id) => !deselected.includes(id));
    return selected.length ? selected : memberIds;
};

export const setSelectedOrgIds = (ids, authUser) => {
    const memberIds = memberOrgIds(authUser);
    const selected = (ids ?? []).map(Number);
    const deselected = memberIds.filter((id) => !selected.includes(id));

    deleteStorage(LEGACY_KEY);
    return setStorage(STORAGE_KEY, deselected);
};

export const ensureOrgSelected = (orgId, authUser) => {
    const id = Number(orgId);
    if (!id) return null;

    const org = getUserOrgs(authUser).find((o) => Number(o?.id) === id);
    if (!org) return null;

    const deselected = readDeselected();
    if (!deselected.includes(id)) return null;

    setStorage(STORAGE_KEY, deselected.filter((x) => x !== id));
    return org;
};

export const getOrgIdsParam = (authUser) => {
    const ids = getSelectedOrgIds(authUser);
    return ids.length ? ids.join(',') : undefined;
};

export const getOrgSelectionLabel = (authUser) => {
    const orgs = getUserOrgs(authUser);
    const selected = getSelectedOrgIds(authUser);

    if (!orgs.length) return 'No organisation';
    if (selected.length === orgs.length) return 'All organisations';

    if (selected.length === 1) {
        const only = orgs.find((o) => Number(o?.id) === Number(selected[0]));
        return only?.name ?? 'Organisation';
    }

    return `${selected.length} of ${orgs.length} organisations`;
};
